var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 50,
    viewBox: "0 0 63 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.375 12.5V13H46.875H56.25C59.4114 13 62 15.5886 62 18.75V49.5H0.5V18.75C0.5 15.5886 3.08864 13 6.25 13H15.625H16.125V12.5V6.25C16.125 3.08864 18.7136 0.5 21.875 0.5H40.625C43.7864 0.5 46.375 3.08864 46.375 6.25V12.5ZM21.875 5.75H21.375V6.25V12.5V13H21.875H40.625H41.125V12.5V6.25V5.75H40.625H21.875ZM56.25 44.25H56.75V43.75V34.375V33.875H56.25H50H49.5V34.375V37H44.25V34.375V33.875H43.75H18.75H18.25V34.375V37H13V34.375V33.875H12.5H6.25H5.75V34.375V43.75V44.25H6.25H56.25ZM49.5 28.125V28.625H50H56.25H56.75V28.125V18.75V18.25H56.25H46.875H15.625H6.25H5.75V18.75V28.125V28.625H6.25H12.5H13V28.125V25.5H18.25V28.125V28.625H18.75H43.75H44.25V28.125V25.5H49.5V28.125Z",
    fill: "current",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.1e8c1024c128d03024869e8563a8b29e.svg";
export { ForwardRef as ReactComponent };